var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTamperingOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.33331L1.16667 24.5H26.8333M14 6.99998L22.785 22.1666H5.215M12.8333 11.6666V16.3333H15.1667V11.6666M12.8333 18.6666V21H15.1667V18.6666",
    fill: "#FF004D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTamperingOn);
export default __webpack_public_path__ + "static/media/ic-tampering-on.cfadfe33e9e957a15574d1095db11f7d.svg";
export { ForwardRef as ReactComponent };